module.exports = __webpack_public_path__ + "img/008.51a6be42.png";